import { toggleMark } from 'prosemirror-commands';
import type { EditorState } from 'prosemirror-state';

import type { LinkAttributes, LinkSchema } from './link-mark';
import { LinkMark } from './link-mark';
import type { ProsemirrorDispatch } from '../../../editor/types';
import { MarkService } from '../../../helpers/mark-base';
import { TextNode } from '../../basic/nodes';

export class PmLinkService<S extends LinkSchema> extends MarkService<S> {
  public setLink(state: EditorState, dispatch: ProsemirrorDispatch, attrs: LinkAttributes) {
    const { $from, $to } = state.selection;
    const hasMark = state.doc.rangeHasMark($from.pos, $to.pos, this.mark);

    if (!hasMark) {
      return toggleMark(this.mark, attrs)(state, dispatch);
    } else {
      const { tr } = state;
      tr.removeMark($from.pos, $to.pos, this.mark);
      tr.addMark($from.pos, $to.pos, this.mark.create(attrs));

      dispatch(tr);
      return;
    }
  }

  public removeLink(state: EditorState, dispatch: ProsemirrorDispatch) {
    const { $from, $to } = state.selection;
    const { tr } = state;

    if ($from.pos === $to.pos) {
      state.doc.nodesBetween($from.pos, $to.pos, (node, pos, parent, index) => {
        if (!TextNode.is(node)) return true;

        if (node.marks.some(mark => LinkMark.is(mark))) {
          tr.removeMark(pos, pos + node.nodeSize, this.mark);
          dispatch(tr);
        }

        return false;
      });
    } else {
      tr.removeMark($from.pos, $to.pos, this.mark);
      dispatch(tr);
    }
  }
}
